import Vue from 'vue'

import { Button,Sidebar,Search,popup,checkbox,checkboxGroup,SidebarItem,Picker ,Row,NoticeBar ,Dialog ,Col,ImagePreview,Tabbar,Skeleton,TabbarItem,NavBar,Tag,Image as VanImage ,Lazyload,Swipe,SwipeItem,Tab, Tabs,Icon,Overlay,Field,Toast,Notify,CountDown,Divider,RadioGroup, Radio,ShareSheet,Sticky,Cell, CellGroup, List,Empty,Loading  } from 'vant'
Vue.use(Button)
Vue.use(Row)
Vue.use(popup)
Vue.use(Search)
Vue.use(Col)
Vue.use(checkbox)
Vue.use(checkboxGroup)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(Lazyload)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Overlay)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Notify)
Vue.use(CountDown)
Vue.use(Divider)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ShareSheet)
Vue.use(Sticky)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Skeleton)
Vue.use(Dialog)
Vue.use(ImagePreview)
Vue.use(NoticeBar)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Picker)